import React, { useState } from 'react';
import { IBlogArticle, IButton } from '../../../../../utils/types/contentful';
import { withLocale } from '../../../../../utils/hocs';
import { ImageHighlight } from '../../ImageHighlight/ImageHighlight';

export interface BlogArticleHightlightCardProps {
  article: IBlogArticle;
  button: IButton;
}

export const BlogArticleHightlightCard = withLocale(
  ({ article, locale, button }: BlogArticleHightlightCardProps) => {
    const formatedBadges = [];
    if (article.categories) {
      for (let i = 0; i < article.categories.length; i++) {
        const category = article.categories[i];
        formatedBadges.push({
          ...category,
          dotColor: category.color,
          label: category.label,
          type: 'white',
        });
      }
    }

    return (
      <ImageHighlight
        image={article.posterImage}
        label={article.label}
        badges={{
          items:
            formatedBadges !== []
              ? formatedBadges.map((b) => ({ ...b, icon: undefined }))
              : undefined,
        }}
        subLabel={article?.subLabel}
        button={{
          ...button,
          type: 'outlined',
          slug: article.slug,
        }}
      />
    );
  }
);
